import type { ReactNode } from "react";
import { t } from "ttag";

import { usePageTitle } from "metabase/hooks/use-page-title";

import { SectionLayout } from "../../components/SectionLayout";

type WorkspacesSectionLayoutProps = {
  children?: ReactNode;
};

export function WorkspacesSectionLayout({
  children,
}: WorkspacesSectionLayoutProps) {
  usePageTitle(t`Workspaces`, { titleIndex: 1 });

  return <SectionLayout>{children}</SectionLayout>;
}
